module.exports = __webpack_public_path__ + "static/media/logo-ct-dashboard.1ad2961d.svg";